<template>
<div class="chapter">
<div class="inner_page">
<div class="frontmatter" title="Don’t Squat with Your Spurs On Vol. 2">
<div class="verso">
<p class="versotitle">Don’t Squat with Your Spurs On Vol. 2</p>
<p class="versotitle">A Cowboy’s Guide to Life</p>
<p>Digital Edition v1.0</p>
<p>Text © 1997 Texas Bix Bender</p>
<p>All rights reserved. No part of this book may be reproduced by any means
                    whatsoever without written permission from the publisher, except brief portions
                    quoted for purpose of review.</p>
<p class="nobreak">Gibbs Smith, Publisher</p>
<p class="nobreak">PO Box 667</p>
<p>Layton, UT 84041</p>
<p class="nobreak">Orders: 1.800.835.4993</p>
<p>www.gibbs-smith.com</p>
<p>ISBN: 978-1-4236-0952-0</p>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// verso.vue?6b8ad89c